export default __webpack_public_path__ + "static/media/paper.b4cd6977.svg";